var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClinicalSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 294.71 260.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#444;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M270.82,26.86l-2.95-2.95a81.55,81.55,0,0,0-115.37,0l-5.15,5.15-5.16-5.15a81.54,81.54,0,0,0-115.36,0l-2.94,2.95a81.57,81.57,0,0,0,0,115.35L138.46,256.79a12.56,12.56,0,0,0,17.77,0l30.47-30.47a11.81,11.81,0,0,0,3.46-8.36v-2.1a11.82,11.82,0,0,0-11.82-11.81h0a11.78,11.78,0,0,0-8.35,3.46l-22.64,22.63-26.09-26.09-46-46L41.66,124.44a56.46,56.46,0,0,1,0-79.82l3-2.95a56.43,56.43,0,0,1,79.82,0l14,14a12.58,12.58,0,0,0,17.77,0l14.06-14a56.39,56.39,0,0,1,79.81,0L253,44.62q1.71,1.7,3.23,3.51a56.43,56.43,0,0,1,2.53,69.58,12.84,12.84,0,0,0-2.53,7.53v.24A12.48,12.48,0,0,0,268.74,138h.05a12.5,12.5,0,0,0,10.06-5.08A81.58,81.58,0,0,0,270.82,26.86Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "294.57 155.06 239.16 155.06 239.16 99.65 207.28 99.65 207.28 155.06 151.87 155.06 151.87 186.94 207.28 186.94 207.28 242.35 239.16 242.35 239.16 186.94 294.57 186.94 294.57 155.06"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicalSupport);
export default __webpack_public_path__ + "static/media/clinical-support.f6fc6c0274b44b08d0190c3c8a9d1f04.svg";
export { ForwardRef as ReactComponent };